import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import SpecComparison from '../../containers/spec-comparison';
import Cta from '../../containers/cta';

const SpecComparisonBlock = props => <SpecComparison {...props} />;
SpecComparisonBlock.displayName = 'SpecComparison';

export default withDynamicComponents({
  componentWhitelist: [
    Cta,
  ],
  mapInputToOutput: [
    ['cta', 'cta'],
  ],
})(SpecComparisonBlock);



// WEBPACK FOOTER //
// ./src/blocks/spec-comparison/index.jsx